
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import Icone from '@/core/components/Icone.vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import storeSistema from '@/store/storeSistema';
import SelecionarEmpresa from '@/components/MeuSistema/Empresas/SelecionarEmpresa.vue';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import ConsultaProdutos from '@/components/Cadastros/Produtos/ConsultaProdutos/ConsultaProdutos.vue';
import { IDTOProdutoDefinicao } from '@/models/DTO/Cadastros/Produtos/IDTOProdutoDefinicao';
import DisponibilidadeProdutos from '@/components/Cadastros/Produtos/ConsultaProdutos/DisponibilidadeProdutos.vue';
import ServicoControleProducao from '@/servicos/Cadastros/PCP/ServicoControleProducao';
import { IControleProducao } from '@/models/Entidades/Cadastros/PCP/IControleProducao';

export default defineComponent({
  name: 'PosicaoEstoque',
  components: {
    TituloPadrao,
    Icone,
    PreviewPdf,
    ConsultaProdutos,
    SelecionarEmpresa,
    DisponibilidadeProdutos,
  },
  setup(props) {
    const {
      telaBase, adicionarAtalho, removerAtalho, verificaConceitoParaApresentarEmpresas, preencherEmpresasDisponiveis,
    } = useTelaBase();
    const servicoControleProducao = new ServicoControleProducao();
    servicoControleProducao.requisicaoSistema();

    const state = reactive({
      empresa: 0,
      tipoVisualizacao: 0,
      arquivosPdf: [] as IArquivoPdf[],
      produtos: [] as IDTOProdutoDefinicao[],
      controles: [] as IControleProducao[],
    });

    function alterarVisualizacao(tipoVisualizacao: number) {
      state.tipoVisualizacao = tipoVisualizacao;
      state.produtos = [];
    }

    async function obterControles() {
      state.controles = await servicoControleProducao.obterAtivos(state.empresa);
    }

    onBeforeMount(async () => {
      telaBase.empresasSelecionadas = storeSistema.getters.empresasUsuarioAutenticado();
      verificaConceitoParaApresentarEmpresas();
      await preencherEmpresasDisponiveis();
      state.empresa = storeSistema.getters.codigoEmpresaOperacao();
      await obterControles();
    });

    return {
      props,
      state,
      telaBase,
      storeSistema,
      ETipoArquivo,
      adicionarAtalho,
      removerAtalho,
      alterarVisualizacao,
    };
  },
});
